<template>
  <h2 class="title" :class="{ 'title--reverse': reverseColors }">
    <span v-html="title" />

    <br />

    <span
      class="subtitle"
      :class="{ 'subtitle--reverse': reverseColors }"
      v-html="subtitle"
    />
  </h2>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    reverseColors: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-family: $bold-font;
  font-size: 88px;
  line-height: 1.07em;
  text-transform: uppercase;

  margin-bottom: 50px;

  @include media-down(xl) {
    line-height: 1em;
    font-size: 59px;
    margin-bottom: 20px;
  }

  @include media-down(lg) {
    line-height: 1em;
    font-size: 65px;
    margin-bottom: 0;
  }

  @include media-down(md) {
    font-size: 30px;
  }

  &--reverse {
    color: $main-color;
  }

  .section-wrapper--loteria & {
    @include media-down(md) {
      width: 104%;
    }
  }
}

.subtitle {
  color: $main-color;

  &--reverse {
    color: $text-color;
  }
}
</style>
